import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonBox from "./Button";

const AlertBox = ({ open, onClickButton, onClickButtonCancel }) => {
    
    return (
        <div>
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle sx={{ fontSize: "18px", color: "#3D2E57" }} id="alert-dialog-title">
                    Are you sure you want to logout?
                </DialogTitle>
                <DialogActions>
                    <ButtonBox color={"#D80027"} onClick={onClickButtonCancel} text={"Cancel"} />
                    <ButtonBox color={"black"} onClick={onClickButton} text={"Confirm"} />
                </DialogActions>
            </Dialog>
        </div>
    );
};
export default AlertBox;
